import { HeroContentWrapper, HeroSectionWrapper } from "./style";
import { PageContainer } from "../../styles/sharedStyled";
import SearchBar from "../../components/shared-components/SearchBar";

function HeroSection() {
  return (
    <HeroSectionWrapper>
      <PageContainer>
        <HeroContentWrapper>
          <h1>Exclusive NFT Drops and Latest Announcements</h1>
          <p>
            Stay updated with our exclusive NFT drops and the latest
            announcements from our team. Don’t miss out on limited-edition
            releases and groundbreaking collaborations that redefine the digital
            art and collectibles space.
          </p>
          <SearchBar />
        </HeroContentWrapper>
      </PageContainer>
    </HeroSectionWrapper>
  );
}

export default HeroSection;
